<template>
  <div>
    <!-- Sekcja 3 najelepszych produktów -->
    <best-products
      v-if="bestProducts && bestProducts.length"
      :products="bestProducts"
      :page="filterPage"
    >
      <template #buttons>
        <nuxt-link :to="localePath('products-bestsellers')">
          <b-button icon-left="bestsellers" class="featured-button">
            {{ $t('fields.bestsellers') }}
          </b-button>
        </nuxt-link>
        <nuxt-link :to="localePath('products-novelties')">
          <b-button icon-left="new" class="featured-button">
            {{ $t('fields.novelties') }}
          </b-button>
        </nuxt-link>
        <nuxt-link :to="localePath('products-sale')">
          <b-button icon-left="sale" class="featured-button">
            {{ $t('fields.sale') }}
          </b-button>
        </nuxt-link>
      </template>
    </best-products>
    <!-- Filtry i lista kategorii -->
    <div class="container main-container main-content">
      <div class="products-and-filters">
        <div class="filters-container is-hidden-desktop">
          <b-button expanded icon-left="customize" @click="toggleFiltersModal()">
            {{ $t('filters.openFilters') }}
          </b-button>
        </div>
        <div class="filters is-hidden-touch">
          <filters
            :categories="categories"
            :current-category="currentCategory"
            :parent-category="parentCategory"
            :options="options"
            :filter-page="filterPage"
          />
        </div>
        <div class="products">
          <div v-if="currentCategory && currentCategory.description" class="homepage-description">
            <div class="container content">
              <p v-html="generate(currentCategory.description)" />
            </div>
          </div>
          <products
            :products="products"
            :options="options"
            :title="getTitle()"
            :rate="rate"
          >
            <template #limit>
              {{ $t('filters.limitOnPage') }}
              <b-field>
                <b-select v-model="limit" placeholder="limi" @input="onLimitChange">
                  <option value="20">
                    20
                  </option>
                  <option value="50">
                    50
                  </option>
                  <option value="100">
                    100
                  </option>
                </b-select>
              </b-field>
            </template>
            <template #pagination>
              <b-pagination
                :total="total"
                :current="page"
                :per-page="limit"
                class="simple-pagination"
                simple
                page-input
                @change="onChange"
              />
            </template>
          </products>
          <b-pagination
            v-if="total > 0"
            :total="total"
            :current="page"
            :per-page="limit"
            :range-before="2"
            :range-after="2"
            @change="onChange"
          />
          <div v-if="currentCategory && currentCategory.descriptionAfter" class="homepage-description">
            <div class="container content">
              <p v-html="generate(currentCategory.descriptionAfter)" />
            </div>
          </div>
          <div v-if="currentCategory && currentCategory.faqsLang && currentCategory.faqsLang.length">
            <faqs :product="currentCategory" />
          </div>
          <div v-if="currentCategory && currentCategory.fullDescriptionByLang" class="category-description">
            <full-description :description="currentCategory.fullDescriptionByLang" />
          </div>
          <b-loading :is-full-page="false" :active.sync="loadingProductsPage" :can-cancel="false" />
        </div>
      </div>
    </div>
    <div class="filters is-hidden-tablet">
      <b-modal
        v-model="filtersModal"
        class="filters-modal"
        has-modal-card
        full-screen
        :can-cancel="false"
      >
        <div class="modal-card">
          <div class="modal-card-head">
            <p class="modal-card-title">
              {{ $t('filters.title') }}
            </p>
          </div>
          <div class="modal-card-body">
            <filters
              ref="filters"
              :categories="categories"
              :current-category="currentCategory"
              :parent-category="parentCategory"
              :options="options"
              :filter-page="filterPage"
            >
              <template #header>
                {{ $t('filters.title') }}
              </template>
              <template #close>
                <b-button expanded @click="toggleFiltersModal()">
                  {{ $t('actions.close') }}
                </b-button>
              </template>
            </filters>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import toSlugText from '~/marketplace-front-core/utils/toSlugText'
import convertOptions from '~/marketplace-front-core/utils/convertOptions'
import Filters from '~/marketplace-front-core/components/products/Filters'
import Products from '~/marketplace-front-core/components/products/Products'
import BestProducts from '~/marketplace-front-core/components/products/BestProducts'
import FullDescription from '~/marketplace-front-core/components/shared/FullDescription'
import Faqs from '~/marketplace-front-core/components/products/ProductFaqs'
import bbcodeHTML from '~/marketplace-front-core/config/bbcodeHTML'

export default {
  components: {
    Products,
    Filters,
    BestProducts,
    FullDescription,
    Faqs
  },
  layout: 'withoutContainer',
  async asyncData ({ app, query, store, params, route, redirect }) {
    let filterPage = null
    let filterFlag = null

    const name = route.name.split('___')
    if (name && name[0]) {
      if (/products-bestsellers/.test(name[0])) {
        filterPage = 'bestsellers'
        filterFlag = 'bestsellerPosition_allTime'
      } else if (/products-novelties/.test(name[0])) {
        filterPage = 'novelties'
        filterFlag = 'newProduct_byTime'
      } else if (/products-sale/.test(name[0])) {
        filterPage = 'sale'
        filterFlag = 'sales'
      }
    }

    const page = query.page ? Number(query.page) : 1
    const limit = query.limit ? Number(query.limit) : 20
    const data = { page, limit, filterFlag }

    if (query.search) { data.keyword = query.search }
    if (query.rate) { data.rate = Number(query.rate) }
    if (query.priceMin) { data.priceMin = Number(query.priceMin) }
    if (query.priceMax) { data.priceMax = Number(query.priceMax) }
    if (query.sort) { data.sort = query.sort }
    if (query.options) { data.option = convertOptions(query.options) }
    if (params.categoryId) { data.category = Number(params.categoryId) }
    const response = await app.$api.default.products(data)

    if (response && response.currentCategory) {
      const categoryName = response.currentCategory.slug
        ? response.currentCategory.slug
        : response.currentCategory.name
          ? toSlugText(response.currentCategory.name)
          : 'category'

      if (params.categoryName !== categoryName) {
        return redirect(301, app.localePath({ params: { categoryName, categoryId: params.categoryId } }))
      }
    }

    return {
      total: response.products.all,
      products: response.products.elements,
      bestProducts: response.bestProducts,
      categories: response.categories,
      currentCategory: response.currentCategory,
      parentCategory: response.parentCategory,
      page,
      limit,
      options: response.filterStructure,
      filterPage,
      filterFlag,
      breadcrumbs: response.breadcrumbs,
      rate: response.rate,
      filtersModal: false
    }
  },
  data () {
    return {
      limit: 20
    }
  },
  head () {
    const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true })
    const links = this._clone(i18nHead.link)
    const mainLang = process.env.lang
    const actualLanguage = this._locale

    if (this.currentCategory) {
      const getNameFromLang = (lang) => {
        const names = this.currentCategory.names
        const slugs = this.currentCategory.slugs

        if (slugs && slugs[lang]) {
          return slugs[lang]
        } else if (names && names[lang]) {
          return toSlugText(names[lang])
        } else if (slugs && slugs[mainLang]) {
          return slugs[mainLang]
        } else if (names && names[mainLang]) {
          return toSlugText(names[mainLang])
        } else if (slugs && slugs.length && slugs[Object.keys(slugs)[0]]) {
          return toSlugText(slugs[Object.keys(slugs)[0]])
        } else if (names && names.length && names[Object.keys(names)[0]]) {
          return toSlugText(names[Object.keys(names)[0]])
        } else {
          return toSlugText('category')
        }
      }

      links.forEach((element) => {
        if (element.hid === 'i18n-alt-' + element.hreflang) {
          element.href = this._frontBaseUrl + this.localePath({ params: { categoryName: getNameFromLang(element.hreflang.toLowerCase()), categoryId: this.$route.params.categoryId } }, element.hreflang.toLowerCase())
        }
        if (element.hid === 'i18n-xd') {
          element.href = this._frontBaseUrl + this.localePath({ params: { categoryName: getNameFromLang(mainLang), categoryId: this.$route.params.categoryId } }, mainLang)
        }
        if (element.hid === 'i18n-can') {
          element.href = this._frontBaseUrl + this.localePath({ params: { categoryName: getNameFromLang(actualLanguage), categoryId: this.$route.params.categoryId } })
        }
      })
    }

    return {
      titleTemplate: '%s',
      title: this.getTitle().name,
      htmlAttrs: {
        ...i18nHead.htmlAttrs
      },
      meta: [
        ...i18nHead.meta
        // ...[{ hid: 'description', name: 'description', content: '' }]
      ],
      link: [
        ...this.metaLink(links)
      ]
    }
  },
  computed: {
    loadingProductsPage () {
      return this.$store.state.page.loadingProductsPage
    }
  },
  watch: {
    $route: {
      handler () {
        this.$store.dispatch('page/update', { name: 'loadingProductsPage', data: false })
      },
      immediate: true,
      deep: true
    }
  },
  watchQuery: true,
  created () {
    if (this.breadcrumbs && this.breadcrumbs.length) {
      const breadcrumbs = []

      this.breadcrumbs.forEach((category) => {
        breadcrumbs.push({
          url: this.localePath({
            name: 'products-category',
            params: {
              categoryName: category.slug || this.toSlugTitle({ name: category.name }),
              categoryId: category.id
            }
          }),
          text: category.name
        })
      })

      if (this.filterPage) {
        breadcrumbs.push({ url: null, text: this.$t(`fields.${this.filterPage}`) })
      }

      this.$store.dispatch('page/update', { name: 'breadcrumbs', data: breadcrumbs })
    } else if (this.filterPage) {
      this.$store.dispatch('page/update', { name: 'breadcrumbs', data: [{ url: null, text: this.$t(`fields.${this.filterPage}`) }] })
    } else {
      this.$store.dispatch('page/update', { name: 'breadcrumbs', data: [{ url: null, text: this.$t('fields.products') }] })
    }
  },
  methods: {
    generate (content, type) {
      return bbcodeHTML(content, type)
    },
    onChange (page, limit) {
      const query = this._clone(this.$route.query)
      query.page = page
      this.$router.push({ query })
      // this.startLoading()
      this.scrollToTop('smooth')
    },
    onLimitChange (limit) {
      const query = this._clone(this.$route.query)
      if (limit === '20') {
        delete query.limit
      } else {
        query.limit = limit
      }
      this.$router.push({ query })
    },
    getTitle () {
      let name = this.$t('fields.products')

      if (this.currentCategory) {
        name = this.currentCategory.name

        if (this.filterPage) {
          name = name + ' - ' + this.$t(`fields.${this.filterPage}`)
        }
      } else if (this.filterPage) {
        name = this.$t(`fields.${this.filterPage}`)
      }

      return {
        name,
        quantity: this.total
      }
    },
    toggleFiltersModal () {
      this.filtersModal = !this.filtersModal
    }
  }
}
</script>
